<template>
  <div v-if="objDTO !== null">
    <div class="container">
      <div class="white-frame" v-if="stage == 1">
        <div class="title-text mb-3">
          <b>Dados do Corretor</b>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="CorretorContactoNome"
              >Corretor</label
            >
            <InputText
              id="CorretorContactoNome"
              name="CorretorContactoNome"
              :value="objDTO.CorretorContacto.Nome"
              readonly="readonly"
              class="form-control"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.CorretorContacto.Email.$invalid,
            }"
          >
            <label class="form-label" for="CorretorContactoEmail"
              >E-mail do corretor</label
            >
            <InputText
              id="CorretorContactoEmail"
              name="CorretorContactoEmail"
              v-model="objDTO.CorretorContacto.Email"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="white-frame" v-if="stage == 1">
        <div class="title-text mb-3">
          <b>Dados do Sinistro</b>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="sinistroData">Data Sinistro</label>
            <Calendar
              id="sinistroData"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              disabled
              class="form-control p-0"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroData.$invalid,
            }"
          >
            <label class="form-label" for="sinistroHora">Hora Sinistro</label>
            <Calendar
              id="sinistroHora"
              v-model="objDTO.Sinistro.SinistroData"
              dateFormat="dd/mm/yy"
              :timeOnly="true"
              hourFormat="24"
              :showSeconds="false"
              :manualInput="false"
              class="form-control p-0"
            />
          </div>

          <div
            class="col-md-12"
            :class="{
              'field-required': $v.objDTO.Sinistro.SinistroDescricao.$invalid,
            }"
          >
            <label class="form-label" for="sinistroDesc"
              >Descrição Ocorrência</label
            >
            <Textarea
              id="sinistroDesc"
              v-model="objDTO.Sinistro.SinistroDescricao"
              :autoResize="true"
              rows="5"
              cols="30"
              class="form-control"
            />
          </div>
        
          <div class="col-md-12">
            <location
              v-if="sinistroLocationObject"
              :value="sinistroLocationObject"
              @locationUpdated="handleSinistroLocationUpdates"
              :validationObject="sinistroLocationValidation"
              locationSectionName="sinistro"
            />
          </div>

          <loading-state v-if="loading.coverages" />

          <div v-if="!loading.coverages" class="row g-3">
            <div
              class="col-md-6"
              v-if="riskUnits.length > 1"
              :class="{
                'field-required':
                  $v.objDTO.Apolice.UnidadeDeRiscoExternalId.$invalid,
              }"
            >
              <label class="form-label" for="riskUnit">Unidade de Risco</label>
              <Dropdown
                id="riskUnit"
                placeholder="Selecione"
                v-model="objDTO.Apolice.UnidadeDeRiscoExternalId"
                :options="riskUnits"
                optionLabel="Description"
                optionValue="RiskUnitId"
                class="form-control p-0"
              />
            </div>
            <div
              class="col-md-6"
              v-if="insuranceObjects.length > 1"
              :class="{
                'field-required':
                  $v.objDTO.Apolice.ObjectoSeguradoExternalId.$invalid,
              }"
            >
              <label class="form-label" for="insuranceObject"
                >Objeto Segurado</label
              >
              <Dropdown
                id="insuranceObject"
                placeholder="Selecione"
                v-model="objDTO.Apolice.ObjectoSeguradoExternalId"
                :options="insuranceObjects"
                optionLabel="Description"
                optionValue="InsuranceObjectId"
                class="form-control p-0"
              />
            </div>
            <div
              class="col-md-6"
              v-if="coverages.length > 1"
              :class="{
                'field-required': $v.objDTO.Apolice.ApoliceCoberturaId.$invalid,
              }"
            >
              <label class="form-label" for="coverages">Cobertura</label>
              <Dropdown
                id="coverages"
                placeholder="Selecione"
                @change="changeCoverage"
                v-model="objDTO.Apolice.ApoliceCoberturaId"
                :options="coverages"
                optionLabel="Description"
                optionValue="GisCoverageId"
                class="form-control p-0"
              />
            </div>
            <div
              class="col-md-6"
              v-if="coverages.length > 0"
              :class="{
                'field-required': $v.objDTO.Sinistro.SinistroEventoId.$invalid,
              }"
            >
              <label class="form-label" for="evento">Evento</label>
              <Dropdown
                id="evento"
                placeholder="Selecione"
                v-model="objDTO.Sinistro.SinistroEventoId"
                :options="events"
                optionLabel="Description"
                optionValue="Id"
                class="form-control p-0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="stage == 1">
      <div class="white-frame">
        <div class="col-md-12">
          <div class="title-text mb-3">
            <b>Dados dos Bens Danificados</b>
          </div>
          <div
            class="col-md-12 pb-3"
            :class="{
              'field-required': $v.objDTO.Veiculo.Obs.$invalid,
            }"
          >
            <label class="form-label" for="bensSinistroDesc"
              >Descrição dos Bens</label
            >
            <Textarea
              id="bensSinistroDesc"
              v-model="objDTO.Veiculo.Obs"
              :autoResize="true"
              maxlength="1000"
              rows="5"
              cols="30"
              class="form-control"
            />
          </div>

          <div
            class="col-md-4"
            :class="{
              'field-required': $v.objDTO.Reserva.ValorReclamado.$invalid,
            }"
          >
            <label class="form-label" for="sinistroHora"
              >Estimativa de Prejuízo</label
            >
            <InputNumber
              id="estimativaPrejuizo"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              v-model="objDTO.Reserva.ValorReclamado"
              :mode="undefined"
              :currency="undefined"
              class="form-control p-0"
              locale="pt-BR"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="stage == 1">
      <div class="white-frame">
        <div class="col-md-12">
          <div class="title-text mb-3">
            <b>Dados Terceiro</b>
          </div>
          <div class="row g-3">
            <div
              class="col-md-12"
              :class="{
                'field-required':
                  $v.objDTO.Sinistro.TerceiroContacto.Nome.$invalid,
              }"
            >
              <label for="nomeTerceiro" class="form-label">Nome</label>
              <InputText
                id="nomeTerceiro"
                v-model="objDTO.Sinistro.TerceiroContacto.Nome"
                class="form-control"
              />
            </div>
            <div
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.Sinistro.TerceiroContacto.Telefone.$invalid,
              }"
            >
              <label for="telefoneTerceiro" class="form-label"
                >Telefone cel.</label
              >
              <imask-input
                id="telefoneTerceiro"
                v-model="objDTO.Sinistro.TerceiroContacto.Telefone"
                class="form-control"
                :mask="phoneMask"
                :unmask="true"
              />
            </div>
            <div
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.Sinistro.TerceiroContacto.Email.$invalid,
              }"
            >
              <label for="emailTerceiro" class="form-label">Email</label>
              <InputText
                id="emailTerceiro"
                v-model="objDTO.Sinistro.TerceiroContacto.Email"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="stage == 1">
      <div class="white-frame">
        <div class="col-md-12">
          <div class="title-text mb-3">
            <b>Dados do Casco</b>
          </div>
          <div class="row g-3">
            <div
              v-if="isAeronautico"
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.EmbarqueTransporte.PrefixoAeronave.$invalid,
              }"
            >
              <label for="prefixoAeronave" class="form-label"
                >Prefixo da aeronave</label
              >
              <InputText
                id="prefixoAeronave"
                v-model="objDTO.EmbarqueTransporte.PrefixoAeronave"
                class="form-control"
              />
            </div>

            <div
              v-if="isAeronautico"
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.EmbarqueTransporte.PilotoNome.$invalid,
              }"
            >
              <label for="pilotoNome" class="form-label">Nome do Piloto</label>
              <InputText
                id="pilotoNome"
                v-model="objDTO.EmbarqueTransporte.PilotoNome"
                class="form-control"
              />
            </div>

            <div
              v-if="isAeronautico"
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.EmbarqueTransporte.ModeloAeronave.$invalid,
              }"
            >
              <label for="modeloAeronave" class="form-label"
                >Modelo da aeronave</label
              >
              <InputText
                id="modeloAeronave"
                v-model="objDTO.EmbarqueTransporte.ModeloAeronave"
                class="form-control"
              />
            </div>

            <div
              v-if="isMaritimo"
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.EmbarqueTransporte.NomeEmbarcacao.$invalid,
              }"
            >
              <label for="nomeEmbarcacao" class="form-label"
                >Nome da embarcação</label
              >
              <InputText
                id="nomeEmbarcacao"
                v-model="objDTO.EmbarqueTransporte.NomeEmbarcacao"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="stage == 1">
      <div class="white-frame">
        <div class="col-md-12">
          <div class="title-text mb-3">
            <b>Dados Vistoria</b>
          </div>
          <div class="row g-3">
            <div
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.Vistoria.VistoriaLocal.Nome.$invalid,
              }"
            >
              <label for="nomeVistoria" class="form-label">Nome Vistoria</label>
              <InputText
                id="nomeVistoria"
                v-model="objDTO.Vistoria.VistoriaLocal.Nome"
                class="form-control"
              />
            </div>

            <div
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.Vistoria.VistoriaLocal.Telefone.$invalid,
              }"
            >
              <label for="telefoneVistoria" class="form-label"
                >Telefone Vistoria</label
              >
              <InputMask
                id="telefoneVistoria"
                v-model="objDTO.Vistoria.VistoriaLocal.Telefone"
                mask="(99) 9999-9999"
                :unmask="true"
                class="form-control"
              />
            </div>

            <div
              class="col-md-6"
              :class="{
                'field-required':
                  $v.objDTO.Vistoria.VistoriaLocal.Email.$invalid,
              }"
            >
              <label for="emailVistoria" class="form-label"
                >Email Vistoria</label
              >
              <InputText
                id="emailVistoria"
                v-model="objDTO.Vistoria.VistoriaLocal.Email"
                class="form-control"
              />
            </div>

            <div class="col-md-12">
              <location
                v-if="vistoriaLocationObject"
                :value="vistoriaLocationObject"
                @locationUpdated="handleVistoriaLocationUpdates"
                :validationObject="vistoriaLocationValidation"
                locationSectionName="vistoria"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container"
      v-if="stage == 1 && !loading.coverages && !$v.objDTO.$invalid"
    >
      <div class="white-frame">
        <div
          class="col-12 Aligner aligner-right mt-4"
          v-if="!$v.objDTO.$invalid"
        >
          <!-- && objDTO.Apolice.ApoliceCoberturaId != 2698 -->
          <button
            class="button-base-small btn-green font-small mx-1"
            @click="stage = 2"
          >
            Finalizar
          </button>
        </div>
      </div>
    </div>

    

    <div v-if="stage === 2">
      <div class="container">
        <div class="white-frame">          
          <!-- <div
            class="output-format d-xl-flex justify-content-xl-evenly  py-xl-3"
          >-->
          <resume-cascos-maritimos-e-aeronauticos :objDTO="objDTO" :events="events" :coverages="coverages" @back="back" />
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LoadingState from "../components/LoadingState.vue";

import { required, minLength } from "vuelidate/lib/validators";
import {  
  dateAfterToday,
  inputClean,
} from "../utils/customValidations";
import { fireGenericError, getInfoByOperationPK } from "../utils/helpers";
import { getEvents, getOptions } from "../api/formMethods";
import { email } from "vuelidate/lib/validators";
import Location from "../components/shared/Location.vue";
import { requiredIf } from "vuelidate/lib/validators";
import GenericLocation from "../utils/classes/GenericLocation";
import { IMaskComponent } from "vue-imask";
import { iMaskConfig, PRODUTOS_AERONAUTICOS, PRODUTOS_MARITIMOS } from "../utils/constants";
import ResumeCascosMaritimosEAeronauticos from "../components/Resume/ResumeCascosMaritimosEAeronauticos.vue";

export default {
  components: {    
    LoadingState,
    Location,
    ResumeCascosMaritimosEAeronauticos,
    "imask-input": IMaskComponent,
  },
  computed: {
    sinistroLocationValidation() {
      return {
        locationObject: {
          address: this.$v.objDTO.Sinistro.SinistroMorada,
          number: this.$v.objDTO.Sinistro.SinistroMoradaNrPorta,
          countryId: this.$v.objDTO.Sinistro.SinistroPaisId,
          countryDescription: this.$v.objDTO.Sinistro.SinistroPaisDescription,
          stateId: this.$v.objDTO.Sinistro.SinistroDistritoId,
          stateDescription: this.$v.objDTO.Sinistro.SinistroDistritoDescripton,
          cityId: this.$v.objDTO.Sinistro.SinistroConcelhoId,
          cityDescription: this.$v.objDTO.Sinistro.SinistroConcelhoDescription,
          localityId: this.$v.objDTO.Sinistro.SinistroFreguesiaId,
          localityDescription: this.$v.objDTO.Sinistro
            .SinistroFreguesiaDescription,
        },
      };
    },
    vistoriaLocationValidation() {
      const vistoriaValidation = this.$v.objDTO.Vistoria.VistoriaLocal;
      return {
        locationObject: {
          address: vistoriaValidation.Morada,
          number: vistoriaValidation.MoradaNrPorta,
          countryId: vistoriaValidation.PaisId,
          stateId: vistoriaValidation.DistritoId,
          stateDescription: vistoriaValidation.DistritoDescripton,
          cityId: vistoriaValidation.ConcelhoId,
          cityDescription: vistoriaValidation.ConcelhoDescription,
          localityId: vistoriaValidation.FreguesiaId,
          localityDescription: vistoriaValidation.FreguesiaDescription,
          countryDescription: vistoriaValidation.PaisDescription,
        },
      };
    },
    isBrasilSinistroSelected() {
      return this.objDTO.Sinistro.SinistroPaisId === this.brasilPaisId;
    },
    isAeronautico() {
      return PRODUTOS_AERONAUTICOS.includes(this.objDTO.Apolice.ApoliceProdutoId);
    },
    isMaritimo() {
      return PRODUTOS_MARITIMOS.includes(this.objDTO.Apolice.ApoliceProdutoId);
    }
  },
  data() {
    return {
      objDTO: null,
      stage: 1,      
      optionYN: [],
      loading: {
        coverages: false,
      },
      insuranceObjects: [],
      riskUnits: [],
      coverages: [],
      events: [],      
      sinistroLocationObject: null,
      vistoriaLocationObject: null,
      phoneMask: iMaskConfig.telemovel,
      brasilPaisId: 3,
    };
  },
  validations() {
    return {
      objDTO: {
        Apolice: {
          ApoliceCoberturaId: { required },
          UnidadeDeRiscoExternalId: { required },
          ObjectoSeguradoExternalId: { required },
        },
        Sinistro: {
          SinistroData: { required, dateAfterToday },

          SinistroEventoId: { required },
          SinistroDescricao: { required, inputClean },

          // Endereço
          SinistroMorada: { required, inputClean },
          SinistroMoradaNrPorta: { required, inputClean },
          SinistroLocalReferencia: { inputClean },

          SinistroPaisId: {
            required
          },
          SinistroPaisDescription: {
            inputClean,
          },
          SinistroDistritoId: {
            required: requiredIf(() => {
              return this.isBrasilSinistroSelected;
            })
          },
          SinistroDistritoDescripton: {
            required,
            inputClean,
          },
          SinistroConcelhoId: {
            required: requiredIf(() => {
              return this.isBrasilSinistroSelected;
            }),
          },
          SinistroConcelhoDescription: {
            required,
            inputClean,
          },
          SinistroFreguesiaId: {
            required: requiredIf(() => {
              return this.isBrasilSinistroSelected;
            }),
          },
          SinistroFreguesiaDescription: {
            required,
            inputClean,
          },
          TerceiroContacto: {
            Nome: {},
            Email: { email },
            Telefone: { minLength: minLength(10) },
          },
        },
        CorretorContacto: {
          Email: { email },
        },
        Reserva: {
          ValorReclamado: {},
        },
        Veiculo: {
          Obs: {},
        },
        Vistoria: {
          VistoriaLocal: {
            Nome: {},
            Email: { email },
            Telefone: { minLength: minLength(10) },

            Morada: { inputClean },
            MoradaNrPorta: { inputClean },
            PaisId: {},
            PaisDescription: {},
            DistritoId: {},
            DistritoDescripton: { inputClean },
            ConcelhoId: {},
            ConcelhoDescription: { inputClean },
            FreguesiaId: {},
            FreguesiaDescription: { inputClean },
          },
        },
        EmbarqueTransporte: {
          PrefixoAeronave: {},
          PilotoNome: {},
          ModeloAeronave: {},
          NomeEmbarcacao: {},
        },
      },
    };
  },
  methods: {
    handleSinistroLocationUpdates(locationObject) {
      if (!locationObject) return;
      
      this.objDTO.Sinistro.SinistroMorada = locationObject.address;
      this.objDTO.Sinistro.SinistroMoradaNrPorta = locationObject.number;
      this.objDTO.Sinistro.SinistroObs = locationObject.complement;

      this.objDTO.Sinistro.SinistroPaisId = locationObject.countryId;
      this.objDTO.Sinistro.SinistroPaisDescription =
        locationObject.countryDescription;
      this.objDTO.Sinistro.SinistroDistritoId = locationObject.stateId;
      this.objDTO.Sinistro.SinistroDistritoDescripton =
        locationObject.stateDescription;
      
      this.objDTO.Sinistro.SinistroConcelhoId = locationObject.cityId;
      this.objDTO.Sinistro.SinistroConcelhoDescription =
        locationObject.cityDescription;
      this.objDTO.Sinistro.SinistroFreguesiaId = locationObject.localityId;
      this.objDTO.Sinistro.SinistroFreguesiaDescription =
        locationObject.localityDescription;
    },
    handleVistoriaLocationUpdates(locationObject) {
      if (!locationObject) return;

      this.objDTO.Vistoria.VistoriaLocal.Morada = locationObject.address;
      this.objDTO.Vistoria.VistoriaLocal.MoradaNrPorta = locationObject.number;
      this.objDTO.Vistoria.VistoriaLocal.PaisId = locationObject.countryId;
      this.objDTO.Vistoria.VistoriaLocal.PaisDescription = locationObject.countryDescription;
      this.objDTO.Vistoria.VistoriaLocal.DistritoId = locationObject.stateId;
      this.objDTO.Vistoria.VistoriaLocal.DistritoDescripton = locationObject.stateDescription;
      this.objDTO.Vistoria.VistoriaLocal.ConcelhoId = locationObject.cityId;
      this.objDTO.Vistoria.VistoriaLocal.ConcelhoDescription = locationObject.cityDescription;
      this.objDTO.Vistoria.VistoriaLocal.FreguesiaId = locationObject.localityId;
      this.objDTO.Vistoria.VistoriaLocal.FreguesiaDescription = locationObject.localityDescription;
      this.objDTO.Vistoria.VistoriaLocal.Obs = locationObject.complement;
    },
    vinculoSegurado(contacto) {
      if (this.objDTO.ComunicanteContacto.ParentescoId == 1) {
        this.objDTO.SeguradoContacto.Nome = contacto.nome;
        this.objDTO.SeguradoContacto.NrContribuinte = contacto.cpf;
      } else {
        this.objDTO.SeguradoContacto.Nome = null;
        this.objDTO.SeguradoContacto.NrContribuinte = null;
      }
    },
    back(newStage) {
      this.stage = newStage;
    },
    async policySelected(operationPK) {
      if (operationPK) {
        window.scrollTo(0, 0);

        try {
          this.loading.coverages = true;

          const {
            riskUnit,
            riskUnits,
            insuranceObject,
            insuranceObjects,
            coverage,
            coverages,
            events,
          } = await getInfoByOperationPK(
            operationPK,
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Sinistro.SinistroRamoId
          );

          this.objDTO.Apolice.UnidadeDeRiscoExternalId = riskUnit;
          this.objDTO.Apolice.ObjectoSeguradoExternalId = insuranceObject;
          this.objDTO.Apolice.ApoliceCoberturaId = coverage;

          this.riskUnits = riskUnits;
          this.events = events;
          this.insuranceObjects = insuranceObjects;
          this.coverages = coverages;
        } catch (error) {
          console.error(error);
          fireGenericError();
        } finally {
          this.loading.coverages = false;
        }
      }
    },
    async changeCoverage() {
      this.objDTO.Sinistro.SinistroEventoId = null;
      this.objDTO.Sinistro.ConstatacaoDanosOpcaoId = null;
      this.objDTO.Sinistro.GuinchoOpcaoId = null;
      this.objDTO.Sinistro.SinistroAnteriorOpcaoId = null;

      this.events = await getEvents(
        this.objDTO.Apolice.ApoliceProdutoId,
        this.objDTO.Apolice.ApoliceCoberturaId,
        this.objDTO.Sinistro.SinistroRamoId
      );
    },
  },
  async mounted() {
    this.objDTO = this.$store.getters.getObjDTO;

    this.sinistroLocationObject = new GenericLocation(
      this.objDTO.Sinistro.SinistroMorada,
      this.objDTO.Sinistro.SinistroMoradaNrPorta,
      this.objDTO.Sinistro.SinistroPaisId,
      this.objDTO.Sinistro.SinistroPaisDescription,
      this.objDTO.Sinistro.SinistroDistritoId,
      this.objDTO.Sinistro.SinistroDistritoDescripton,
      this.objDTO.Sinistro.SinistroConcelhoId,
      this.objDTO.Sinistro.SinistroConcelhoDescription,
      this.objDTO.Sinistro.SinistroFreguesiaId,
      this.objDTO.Sinistro.SinistroFreguesiaDescription,
      this.objDTO.Sinistro.SinistroLocalReferencia
    );

    this.vistoriaLocationObject = new GenericLocation(
        this.objDTO.Vistoria.VistoriaLocal.Morada,
        this.objDTO.Vistoria.VistoriaLocal.MoradaNrPorta,
        this.objDTO.Vistoria.VistoriaLocal.PaisId,
        this.objDTO.Vistoria.VistoriaLocal.PaisDescription,
        this.objDTO.Vistoria.VistoriaLocal.DistritoId,
        this.objDTO.Vistoria.VistoriaLocal.DistritoDescripton,
        this.objDTO.Vistoria.VistoriaLocal.ConcelhoId,
        this.objDTO.Vistoria.VistoriaLocal.ConcelhoDescription,
        this.objDTO.Vistoria.VistoriaLocal.FreguesiaId,
        this.objDTO.Vistoria.VistoriaLocal.FreguesiaDescription,
        this.objDTO.Vistoria.VistoriaLocal.Obs,
      );

    
    await this.policySelected(this.objDTO.Apolice.ApoliceContrato);
    this.optionYN = await getOptions();
  },
  beforeDestroy() {
    // this.objDTO.Sinistro.SinistroDescricao = null;
    // this.objDTO.Apolice.UnidadeDeRiscoExternalId = null;
    // this.objDTO.Apolice.ObjectoSeguradoExternalId = null;
    // this.objDTO.Apolice.ApoliceCoberturaId = null;

    // this.objDTO.Sinistro.SinistroEventoId = null;
    // this.objDTO.Sinistro.SinistroCodigoPostal = null;
    // this.objDTO.Sinistro.SinistroDistritoId = null;
    // this.objDTO.Sinistro.SinistroConcelhoId = null;
    // this.objDTO.Sinistro.SinistroFreguesiaId = null;
    // this.objDTO.Sinistro.SinistroMorada = null;
    // this.objDTO.Sinistro.SinistroMoradaNrPorta = null;
    // this.objDTO.Sinistro.SinistroLocalReferencia = null;

    // this.objDTO.Sinistro.ConstatacaoDanosOpcaoId = null;
    // this.objDTO.Sinistro.GuinchoOpcaoId = null;
    // this.objDTO.Sinistro.SinistroAnteriorOpcaoId = null;
  },
};
</script>
